import JobCategoriesDialog from './JobCategoriesDialog';

export default JobCategoriesDialog;
